export default function initProdutosRelacionadosCategorias() {
    const swiperContainer = document.querySelector('.tax-categoria-produto .c-related-products__swiper');

    if (!swiperContainer) return;

    const isProductListing = Boolean(swiperContainer.closest('.p-products'));

    const relatedProductsSwiper = new Swiper(swiperContainer, {

        slidesPerView: 1.4,
        spaceBetween: 15,
        grabCursor: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,

        a11y: {
            enabled: true,
            prevSlideMessage: 'Slide anterior',
            nextSlideMessage: 'Próximo slide',
            firstSlideMessage: 'Este é o primeiro slide',
            lastSlideMessage: 'Este é o último slide',
            paginationBulletMessage: 'Ir para o slide {{index}}',
        },

        navigation: {
            nextEl: '.tax-categoria-produto .c-related-products__arrow--next.js-related-next',
            prevEl: '.tax-categoria-produto .c-related-products__arrow--prev.js-related-prev',
        },

        pagination: {
            el: '.tax-categoria-produto .swiper-pagination',
            clickable: true,
        },

        breakpoints: {
            992: {
                slidesPerView: isProductListing ? 2.4 : 3.4,
                spaceBetween: 20,
                slidesOffsetBefore: 50,
                slidesOffsetAfter: 50,
            }
        }
    });

    return relatedProductsSwiper;
}
